const getProcessedValue = (
  field:
    | {
        processed?: string | null | undefined;
      }
    | null
    | undefined
) => {
  if (field) {
    return field.processed ? field.processed : '';
  }

  return '';
};

export default getProcessedValue;
